// optimization
// ToDo:: saparate the header section(search, shipment filter, buttons etc..)
// ToDo: setSelectedColumn, setSearchText - remove these callbacks, use updated data from redux store.(the are calling only when click on search icon only, that's placed. try to optimise these)
// ToDo: split the code to small saparate files
import {
    Box,
    Button,
    Icon,
    IconButton,
    Tooltip,
    Typography,
} from '@mui/material'

import { CloseOutlined, SwapHorizOutlined } from '@mui/icons-material'
import { useInfiniteQuery, useQueryClient } from '@tanstack/react-query'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { MRT_RowSelectionState } from 'material-react-table'
import {
    memo,
    ReactElement,
    SetStateAction,
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'
import {
    Applications,
    AttributesMetadata,
    columsnToExcludeInEntityListing,
    EntityInstanceTypes,
    EntityStatus,
    EntityStatusBEtoUI,
    DeviceManagerStatusToUI,
    DEVICE_MANAGER_REGISTERED,
    FMTABS,
    DEVICE_MANAGER_TABS,
    PREVIEW_MODE,
    RoutePaths,
    RELATION_TYPE_PARENT,
    SEARCH_ATTRIBUTE_TYPE_PARENT_RELATION,
    TAB_PAGE_VIEW,
    URLSearchParamsKeys,
    USER_ROLES,
    UserPermissions,
} from '../../../constants/constants'
import useDebounce from '../../../CustomHooks/useDebounce'
import useEntityInstanceFiltersInit from '../../../CustomHooks/useEntityInstanceFiltersInit'
import { useAppDispatch, useAppSelector } from '../../../redux/hook'
import {
    setAvailableOrgList,
    updateInstanceReadOnly,
} from '../../../redux/slices/entityInstanceSlice'
import {
    ColumnOrderListType,
    getEntityListColumns,
    setFilterList,
    setScrollPosition,
    updateEntityListColumns,
} from '../../../redux/slices/entitySlice'
import { updateLoader } from '../../../redux/slices/loaderSlice'
import {
    exportEntityRecordsAsXLS,
    ExportShipmentEntityRecordsParams,
    fetchEntityRecordsList,
    FetchShipmentEntityRecordsParams,
    postColumnsSelections,
    updateEntityInstancesStatus,
} from '../../../services/entityServices'
import theme from '../../../theme/theme'
import {
    canEditEntity,
    deriveColumnFiltersFromStore,
    findEntityById,
    isCompletedDevice,
    getEntityTableEntityStatusFilter,
    getEntityTableFilters,
    getEntityTableGlobalSearchTextFilter,
    getNonColumnLevelFilters,
} from '../../../utils/EntityUtils'
import {
    getAlarmStatusFilters,
    getColumnFilters,
    getShipmentStatusFilters,
    selectionHasCompletedShipment,
} from '../../../utils/IntransitUtils'
import {
    isCreationDateTime,
    isDateTime,
    isEntity,
    isEntityJson,
    isFile,
    isGeoFence,
    isGPS,
    isJson,
    isPDFBase64,
    isStatic,
    isURL,
} from '../../../utils/MiscellaneousUtils'
import InTransitFilterRow from '../../Applications/Intransit/InTransitFilterRow'
import EntityBulkUploadModal from '../../Applications/UploadManager/EntityBulkUploadModal'
import CertificateViewer from '../../Common/Base64ToPDF'
import ColumnsArrangement from '../../Common/ColumnsArrangement'
import ConfirmationDialog from '../../Common/ConfirmationDialog'
import DatetimeTypeData from '../../Common/DatetimeTypeData'
import DynamicTable from '../../Common/DynamicTable'
import EntityFileTypeData from '../../Common/EntityFileTypeData'
import EntityJsonTypeData from '../../Common/EntityJsonTypeData'
import EntityTableCell from '../../Common/EntityTableCell'
import EntityTableHeader from '../../Common/EntityTableHeader'
import EntityTypeData from '../../Common/EntityTypeData'
import GeoJSONTypeData from '../../Common/GeoJsonTypeData'
import TruncatedText from '../../Common/TruncatedText'
import URLTypeData from '../../Common/URLTypeData'
import { EntityType } from '../../DTStudio/interfaces'
import ErrorBoundary from '../../ErrorBoundaries/ErrorBoundary'
import CustomFilters from '../Components/CustomFilters'
import EntityListSearch from '../Components/EntityListSearch'
import EntityInstance from '../EntityInstance'
import ExportColumnsPopup from '../ExportColumnsPopup'
import {
    IColumn,
    IDateFilter,
    IEntityListRecord,
    IEntityTableDefinition,
    IFilterValue,
    IGlobalSearchTextFilter,
    IMRTColumn,
    ITableFilters,
} from '../interfaces'
import EntityStatusFilter from '../Components/EntityStatusFilter'
import BulkCompleteAction from '../Components/BulkComplete/BulkCompleteAction'
import TransferInstancesModal from '../Components/TansferInstancesModal'

dayjs.extend(utc)

interface IEntity {
    templateId: string
    previewMode?: string
    tabIndex?: number
    applicationId?: string
    isInTransitMapView?: boolean
    mapLayout?: 'both' | 'table-only'
    onMapLayoutChange?: (layout: 'both' | 'table-only') => void
    setSelectedColumn?: (value: SetStateAction<IColumn | null>) => void
    setSearchText?: (value: SetStateAction<string>) => void
    onShowMarkerInfo?: (shipmentUid: string) => void
    onTotalCountWithoutFiltersChange?: (count: number) => void
    viewport?: google.maps.LatLngBoundsLiteral | null
    listQueryParams?: { [key: string]: string | number | boolean }
    sortParams?: {
        orderAttribute: string
        orderBy: 'ASC' | 'DESC'
    }
    setSortParams?: (
        value: SetStateAction<{
            orderAttribute: string
            orderBy: 'ASC' | 'DESC'
        }>,
    ) => void
}

//use this component to render the list of entities
//send needed values as props
const EntityList = (props: IEntity): ReactElement => {
    const { t } = useTranslation()
    const queryClient = useQueryClient()
    const {
        templateId,
        previewMode = PREVIEW_MODE.VIEW_ENTITY_DETAILS,
        tabIndex,
        applicationId,
        isInTransitMapView = false,
        mapLayout,
        onMapLayoutChange,
        viewport,
        listQueryParams = {},
        onShowMarkerInfo,
        onTotalCountWithoutFiltersChange,
        setSelectedColumn,
        setSearchText,
        sortParams: sortParamsFromProps,
        setSortParams: setSortParamsFromProps,
    } = props
    const [displayMapLayout, setDisplayMapLayout] = useState<
        'both' | 'table-only'
    >(mapLayout ?? 'both')
    const [, setSearchParams] = useSearchParams()
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const navList = useAppSelector((state) => state.nav.navList)
    const org = useAppSelector((state) => state.org.org)
    const permissions = useAppSelector((state) => state.org.permissions)
    const canImportExport =
        permissions.includes(UserPermissions.USER_ADMIN) ||
        permissions.includes(UserPermissions.ORG_ADMIN) ||
        permissions.includes(UserPermissions.ENTITY_WRITER) ||
        permissions.includes(UserPermissions.ENTITY_ANALYST) ||
        permissions.includes(UserPermissions.DEVICE_WRITER)

    const enabledApplications = useAppSelector(
        (state) => state.org.enabledApplications,
    )

    const availableOrgList = useAppSelector(
        (state) => state.entityInstance.availableOrgList,
    )

    const user = useAppSelector((state) => state.user.user)
    const userUnits = useAppSelector(
        (state) => state.user.user?.preferences?.units,
    )
    const userUnitsKey = useMemo(
        () => (userUnits ? JSON.stringify(userUnits) : ''),
        [userUnits],
    )
    const userLocalization = useAppSelector(
        (state) => state.user.user?.preferences?.localization,
    )
    const shipmentRelations = useAppSelector(
        (state) => state.inTransit.shipmentRelations,
    )
    const inTransitSettings = useAppSelector(
        (state) => state.inTransit.inTransitSettings,
    )

    const rawColumnVisibilityList = useAppSelector(
        (state) => state.entity.entityColumns,
    )

    const isDeviceManagerListingView =
        applicationId === Applications.deviceManager.id &&
        tabIndex === DEVICE_MANAGER_TABS.LIST_VIEW

    // Hide entityStatus column when not in cross-org (fetchAll) view
    const columnVisibilityList = useMemo(
        () =>
            isDeviceManagerListingView
                ? rawColumnVisibilityList
                : rawColumnVisibilityList.filter(
                      (col) => col.attributeName !== 'entityStatus',
                  ),
        [rawColumnVisibilityList, isDeviceManagerListingView],
    )

    const allTableFilters = useAppSelector(
        (state) => state.entity.allTableFilters,
    )

    const isFetchingColumn = useAppSelector(
        (state) => state.entity.isFetchingColumn,
    )
    const columnVisibilityTemplateId = useAppSelector(
        (state) => state.entity.columnVisibilityTemplateId,
    )
    const columnVisibilityOrgId = useAppSelector(
        (state) => state.entity.columnVisibilityOrgId,
    )
    const userRole = useAppSelector((state) => state.user.user?.role) ?? ''

    const shipmentStatusAttributeId =
        inTransitSettings?.shipmentStatusAttributeId || 'shipmentStatus'
    const alarmStatusAttributeId =
        inTransitSettings?.alarmStatusAttributeId || 'alarmStatus'
    const dateFilterAttributeId = inTransitSettings?.dateFilter || ''

    const maritimeTrackingRelationName =
        shipmentRelations.find(
            (relation) =>
                relation.childEntity ===
                inTransitSettings?.searatesEntityTemplateId,
        )?.relationName || ''

    const templateData = useMemo(
        () =>
            (templateId && findEntityById(navList, templateId)?.entity) ||
            ({} as EntityType),
        [templateId, navList],
    )
    const userTimeZone = userLocalization?.timeZone || dayjs.tz.guess()

    const isReportsListingView =
        applicationId === Applications.facilityMonitoring.id &&
        tabIndex === FMTABS.REPORTS

    // if template device:writer permission is true. then that template is consider as "device" template. we need to give writer permission to superAdimn or deviceManger only
    const isDeviceTemplate = useMemo(() => {
        return !!templateData?.permissions?.writer?.device
    }, [templateData])

    const isSuperAdmin = useMemo(
        () => permissions?.includes(UserPermissions.ORG_ADMIN),
        [permissions],
    )

    const enableBulkUpload = isDeviceTemplate ? false : isSuperAdmin

    const isAdmin = useMemo(
        () => permissions?.includes(UserPermissions.USER_ADMIN),
        [permissions],
    )

    const isDeviceManager = useMemo(
        () =>
            userRole === USER_ROLES.DEVICE_MANAGER ||
            permissions?.includes(UserPermissions.ORG_ADMIN),
        [permissions, userRole],
    )
    // Add button in Device Manager: only device:writer, Device Manager role, or Super Admin (not plain Org Admin)
    const hasDeviceWritePermission = useMemo(
        () =>
            permissions?.includes(UserPermissions.DEVICE_WRITER) ||
            permissions?.includes(UserPermissions.ORG_ADMIN) ||
            userRole === USER_ROLES.DEVICE_MANAGER ||
            userRole === USER_ROLES.SYSTEM_ADMIN,
        [permissions, userRole],
    )

    const canEdit =
        isDeviceTemplate || isDeviceManagerListingView
            ? hasDeviceWritePermission
            : (applicationId === Applications.analytics.id &&
                  permissions.includes(UserPermissions.ORG_ADMIN)) ||
              (applicationId !== Applications.analytics.id &&
                  permissions.includes(UserPermissions.ENTITY_WRITER))
    const isMaritimeTrackingEnabled = enabledApplications.includes(
        Applications.maritimeTracking.id,
    )

    const currentLocationBounds = useMemo(() => {
        return viewport
            ? [
                  viewport?.west ?? '',
                  viewport?.east ?? '',
                  viewport?.south ?? '',
                  viewport?.north ?? '',
              ].join(',')
            : ''
    }, [viewport])

    const DateFilterAttributeName = useMemo(() => {
        return (
            columnVisibilityList.find(
                (i) => i.id === inTransitSettings?.dateFilter,
            )?.name || ''
        )
    }, [columnVisibilityList, inTransitSettings])

    const fetchSize = 30

    const [internalSortParams, setInternalSortParams] = useState<{
        orderAttribute: string
        orderBy: 'ASC' | 'DESC'
    }>({
        orderAttribute: '',
        orderBy: 'ASC',
    })

    // Use props if provided, otherwise use internal state
    const sortParams = sortParamsFromProps || internalSortParams
    const setSortParams = setSortParamsFromProps || setInternalSortParams
    const [entityData, setEntityData] = useState<{
        templateName: string
        templateId: string
        entityId: string
        orgId: string
    }>({
        templateName: '',
        templateId: '',
        entityId: '',
        orgId: '',
    })
    const [openEntityInstance, setOpenEntityInstance] = useState(false)
    const [isEdit, setIsEdit] = useState<boolean>(false)
    const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({})
    const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false)
    const [rowsToDelete, setRowsToDelete] = useState<number[]>([])
    // UBQ-5177: guards a fast double-click on the delete confirm — prevents a second,
    // in-flight submit from firing a duplicate (or empty-selection) delete request.
    const isDeletingRef = useRef<boolean>(false)
    const [hasSearchFilter, setHasSearchFilter] = useState<boolean>(false)
    const [openTransfer, setOpenTransfer] = useState<boolean>(false)

    const tabIndexString = tabIndex?.toString() || '0'
    useEntityInstanceFiltersInit(
        templateId,
        applicationId,
        tabIndexString,
        isInTransitMapView,
    )
    const allAttributesFilters: Record<string, IFilterValue> =
        getEntityTableFilters(
            allTableFilters,
            templateId,
            applicationId,
            tabIndexString,
        )

    const columnFilters = useMemo(() => {
        return deriveColumnFiltersFromStore(
            allAttributesFilters,
            columnVisibilityList,
        )
    }, [allAttributesFilters, columnVisibilityList])

    const fromDate =
        (allAttributesFilters[dateFilterAttributeId]?.startDate as string) || ''
    const toDate =
        (allAttributesFilters[dateFilterAttributeId]?.endDate as string) || ''

    const dateRange: [string | null, string | null] = useMemo(() => {
        return [fromDate || null, toDate || null]
    }, [fromDate, toDate])

    const gloalSearchText: IGlobalSearchTextFilter | undefined =
        getEntityTableGlobalSearchTextFilter(
            allTableFilters,
            templateId,
            applicationId,
            tabIndexString,
        )

    const entityStatusValue = useMemo(() => {
        const values = getEntityTableEntityStatusFilter(
            allTableFilters,
            templateId,
            applicationId,
            tabIndexString,
        )?.values

        if (isDeviceManagerListingView) {
            if (!values?.length) {
                return [EntityStatus.ACTIVE, EntityStatus.ARCHIVE]
            }
            // Map virtual REGISTERED to ACTIVE for the backend; deduplicate
            const backendStatuses = new Set<string>()
            ;(values as string[]).forEach((v) => {
                if (
                    v === DEVICE_MANAGER_REGISTERED ||
                    v === EntityStatus.ACTIVE
                ) {
                    backendStatuses.add(EntityStatus.ACTIVE)
                } else {
                    backendStatuses.add(v)
                }
            })
            return [...backendStatuses]
        }

        return values
    }, [
        allTableFilters,
        templateId,
        applicationId,
        tabIndexString,
        isDeviceManagerListingView,
    ])

    // Device Manager only: drives hasActiveRelation backend param
    // Only set when selection is purely REGISTERED or purely ACTIVE (not mixed with ARCHIVE)
    const deviceManagerRelationFilter = useMemo((): boolean | null => {
        if (!isDeviceManagerListingView) return null
        const values = getEntityTableEntityStatusFilter(
            allTableFilters,
            templateId,
            applicationId,
            tabIndexString,
        )?.values
        if (!values?.length) return null
        const strValues = values as string[]
        const hasRegistered = strValues.includes(DEVICE_MANAGER_REGISTERED)
        const hasActive = strValues.includes(EntityStatus.ACTIVE)
        // Archive is independent — filtered by filterBy, not hasActiveRelation
        if (hasRegistered && !hasActive) return false
        if (hasActive && !hasRegistered) return true
        return null
    }, [
        allTableFilters,
        templateId,
        applicationId,
        tabIndexString,
        isDeviceManagerListingView,
    ])

    const searchValue = gloalSearchText?.searchText.trim() || ''
    const selectedColumn = gloalSearchText?.column || null

    const assetEntityTemplateId = useAppSelector(
        (state) => state.facilityMonitoring.assetEntityTemplateId,
    )

    const hasParentRelationColumns = useMemo(
        () =>
            templateId === assetEntityTemplateId &&
            columnVisibilityList.some(
                (col) => col.relationType === RELATION_TYPE_PARENT,
            ),
        [columnVisibilityList, templateId, assetEntityTemplateId],
    )

    const triggerSearch = useCallback(
        (searchText?: string) => {
            queryClient.invalidateQueries({
                queryKey: ['entity-instances-table-data'],
            })
            if (isInTransitMapView) {
                setSearchText?.(searchText ?? searchValue)
                setSelectedColumn?.(selectedColumn)
            }
        },
        [
            searchValue,
            selectedColumn,
            setSearchText,
            setSelectedColumn,
            isInTransitMapView,
            queryClient,
        ],
    )
    const updateDateRange = useCallback(
        (newDateRange: [string, string]) => {
            const updatedAllTableFilters = allTableFilters.map((filter) => {
                if (
                    filter.applicationId === applicationId &&
                    filter.tabIndex === tabIndexString &&
                    filter.entityTemplateId === templateId
                ) {
                    return {
                        ...filter,
                        allAttributesFilters: {
                            ...filter.allAttributesFilters,
                            [dateFilterAttributeId]: {
                                type: 'date',
                                isColumnLevelFilter: false,
                                startDate: newDateRange[0],
                                endDate: newDateRange[1],
                            } as IDateFilter,
                        },
                    } as ITableFilters
                }
                return filter
            })
            dispatch(setFilterList(updatedAllTableFilters))
        },
        [
            allTableFilters,
            applicationId,
            tabIndexString,
            templateId,
            dateFilterAttributeId,
            dispatch,
        ],
    )

    const [uploadModalOpen, setUploadModalOpen] = useState(false)
    const [modalMode, setModalMode] = useState<'upload' | 'download' | 'both'>(
        'both',
    )
    const currentTemplates = useMemo(() => {
        const orgTemplates =
            availableOrgList.find((o) => o.id === org?.id)?.templates || []

        if (orgTemplates.length > 0) {
            return orgTemplates.map((t) => ({
                id: t.id,
                name: t.name,
                subEntityTypes: [],
            }))
        }

        if (!templateData?.id) return []
        return [
            {
                id: templateData.id,
                name: templateData.name,
                subEntityTypes: templateData.subEntityTypes?.map((sub) => ({
                    id: sub.id,
                    name: sub.name,
                    subEntityTypes: sub.subEntityTypes,
                })),
            },
        ]
    }, [templateData, availableOrgList, org?.id])

    const bulkUploadInitialTemplateId = useMemo(() => {
        const orgTemplates =
            availableOrgList.find((o) => o.id === org?.id)?.templates || []
        if (orgTemplates.length > 0) {
            return orgTemplates.length === 1 ? orgTemplates[0].id : ''
        }
        return templateId
    }, [availableOrgList, org?.id, templateId])

    const handleBulkActionClick = () => {
        dispatch(setAvailableOrgList({ orgId: org?.id || '', templateId }))
        setModalMode('both')
        setUploadModalOpen(true)
    }

    const isInitialLoad = useRef(true)
    const prevUserUnitsKeyRef = useRef<string>(userUnitsKey)
    const debounceValue = isInitialLoad.current ? 10 : 1000

    const shipmentStatusFilter = getShipmentStatusFilters(
        allAttributesFilters,
        shipmentStatusAttributeId,
    )

    const alarmStatusFilter = getAlarmStatusFilters(
        allAttributesFilters,
        alarmStatusAttributeId,
    )

    const debouncedShipmentStatusFilter = useDebounce(
        shipmentStatusFilter,
        debounceValue,
    )

    const debouncedAlarmStatusFilter = useDebounce(
        alarmStatusFilter,
        debounceValue,
    )

    const debouncedColumnFilters = useDebounce(columnFilters, debounceValue)
    const debouncedEntityStatus = useDebounce(entityStatusValue, debounceValue)
    const debouncedRelationFilter = useDebounce(
        deviceManagerRelationFilter,
        debounceValue,
    )

    /**
     * In EntityListSearch.tsx we are setting the searchable column to the first searchable column in
     * columnVisibilityList. If no searchable column is found, we set it to null. Hence we are comparing
     * gloalSearchText?.column !== undefined to check if the searchable column is initialized or not.
     */
    const isGlobalSearchColumnInitialized =
        gloalSearchText?.column !== undefined

    const { data, fetchNextPage, isError, isFetching, isLoading } =
        useInfiniteQuery<IEntityTableDefinition>({
            queryKey: [
                'entity-instances-table-data',
                // searchValue, // Commented to avoid refetch on each key stroke
                templateId,
                org?.id,
                debouncedShipmentStatusFilter,
                debouncedAlarmStatusFilter,
                fromDate,
                toDate,
                user,
                currentLocationBounds,
                listQueryParams,
                sortParams,
                debouncedColumnFilters,
                columnVisibilityList,
                debouncedEntityStatus,
                debouncedRelationFilter,
            ],
            queryFn: async ({ pageParam }) => {
                const filters = getColumnFilters(
                    debouncedColumnFilters,
                    columnVisibilityList,
                )
                const queryParams: FetchShipmentEntityRecordsParams = {
                    pageNo: (pageParam as number) + 1,
                    pageSize: fetchSize,
                    searchText: searchValue?.trim(),
                    shipmentStatusFilter: debouncedShipmentStatusFilter,
                    alarmStatusFilter: debouncedAlarmStatusFilter,
                    searchAttributeName: searchValue
                        ? selectedColumn?.attributeName || ''
                        : '',
                    searchAttributeType: searchValue
                        ? selectedColumn?.relationType === RELATION_TYPE_PARENT
                            ? SEARCH_ATTRIBUTE_TYPE_PARENT_RELATION
                            : selectedColumn?.attributeType || ''
                        : '',
                    dateFilterAttributeId,
                    fromDate,
                    toDate,
                    currentLocationBounds,
                    ...listQueryParams,
                    orderAttribute: sortParams.orderAttribute,
                    orderBy: sortParams.orderBy,
                    filters,
                    filterBy: debouncedEntityStatus as EntityStatus[],
                    entitySearch: !!searchValue,
                    includeParentRelations: hasParentRelationColumns,
                    roleBasedFetchAll: isDeviceManagerListingView,
                    ...(debouncedRelationFilter !== null && {
                        hasActiveRelation: debouncedRelationFilter,
                    }),
                }
                const response = await fetchEntityRecordsList(
                    org?.id || '',
                    templateId,
                    queryParams,
                )

                // if (!response?.data?.length && pageParam === 0) {
                //     throw new Error('No data available')
                // }

                // TO DO:: we need to find out "Clear X" button count. if we has search filter we need to update count.
                // to find out has search filter or not. we need to depend on "seachValue". but now searchValue is updating on each key stroke. but records API is calling only hitting "search icon". so, we are traking like later we need to update this
                isInitialLoad.current = false
                setHasSearchFilter(!!searchValue)
                return response as IEntityTableDefinition
            },
            initialPageParam: 0,
            getNextPageParam: (lastPage, pages) => {
                if (!lastPage?.data?.length) {
                    return undefined
                }

                const totalFetched = pages.reduce(
                    (acc, page) => acc + (page?.data?.length || 0),
                    0,
                )
                if (totalFetched >= (lastPage?.totalRowCount || 0)) {
                    return undefined
                }

                return pages.length
            },
            staleTime: 0,
            gcTime: 1000 * 60 * 10, // 10 minutes
            refetchOnMount: true,
            refetchOnWindowFocus: false,
            // placeholderData: (prev) => prev,
            enabled:
                !isFetchingColumn &&
                columnVisibilityTemplateId === templateId &&
                columnVisibilityOrgId === org?.id &&
                columnVisibilityList.length > 0 &&
                isGlobalSearchColumnInitialized,
        })
    const flatData = useMemo(
        () => data?.pages?.flatMap((page) => page.data) ?? [],
        [data],
    )
    //this is the total row count with filters
    const totalDBRowCount = useMemo(
        () => data?.pages?.[0]?.totalRowCount ?? 0,
        [data],
    )
    //this is the total row count without filters
    const totalDBRowCountWithoutFilters = useMemo(
        () => data?.pages?.[0]?.totalCount ?? 0,
        [data],
    )
    // visible columns in list
    const columnVisibility = useMemo(() => {
        const selectedColumns: Record<string, boolean> = {}
        columnVisibilityList?.forEach((i) => {
            selectedColumns[i.id] = i.selected
        })
        return selectedColumns
    }, [columnVisibilityList])
    // columns order
    const columnOrder = useMemo(() => {
        if (columnVisibilityList.length === 0) {
            return []
        }

        const staticColumnKeys: string[] = []

        if (canEdit || isSuperAdmin) {
            staticColumnKeys.push('mrt-row-select')
        }

        staticColumnKeys.push('viewid')
        if (canEdit) {
            staticColumnKeys.push('editid')
        }
        staticColumnKeys.push('shipIcon')

        const dynamicColumnOrder = columnVisibilityList.map((item) => item.id)

        const columnOrder = [...staticColumnKeys, ...dynamicColumnOrder]
        return columnOrder
    }, [columnVisibilityList, canEdit, isSuperAdmin])
    const rowsSeletced = useMemo(
        () => Object.keys(rowSelection).length > 0,
        [rowSelection],
    )
    const selectedRowInstanceIds: string[] = useMemo(() => {
        const keys = Object.keys(rowSelection)
        const selectedRows: string[] = []
        for (const k of keys) {
            const key = Number(k)
            const rowData: any = flatData[key]
            selectedRows.push(rowData?.entityId)
        }
        return selectedRows
    }, [rowSelection, flatData])

    // If any selected shipment is already completed, the whole "Complete Selected"
    // action is disabled (UBQ-5245).
    const hasCompletedSelection: boolean = useMemo(
        () =>
            selectionHasCompletedShipment(
                rowSelection,
                flatData,
                shipmentStatusAttributeId,
            ),
        [rowSelection, flatData, shipmentStatusAttributeId],
    )

    const selectedRowOrgIds: string[] = useMemo(() => {
        const keys = Object.keys(rowSelection)
        const selectedRows: string[] = []
        for (const k of keys) {
            const key = Number(k)
            const rowData: any = flatData[key]
            selectedRows.push(rowData?.organizationId)
        }
        return selectedRows
    }, [rowSelection, flatData])

    const isPreviewEnabled = useMemo(
        () => data?.pages?.[0]?.isPreviewEnabled ?? false,
        [data?.pages],
    )

    const onClickEditIcon = useCallback(
        (row: any) => {
            if (canEditEntity(row, isSuperAdmin)) {
                setOpenEntityInstance(true)
                setIsEdit(true)
                setEntityData({
                    templateName: row.templateName,
                    templateId: row.templateId,
                    entityId: row?.entityId,
                    orgId: row.organizationId,
                })
            }
        },
        [isSuperAdmin],
    )

    const onClickReadOnly = useCallback(
        (row: any) => {
            setOpenEntityInstance(true)
            setIsEdit(true)
            setEntityData({
                templateName: row.templateName,
                templateId: row.templateId,
                entityId: row?.entityId,
                orgId: row.organizationId,
            })

            dispatch(updateInstanceReadOnly(true))
        },
        [dispatch],
    )

    const onClickPreview = useCallback(
        (row: any) => {
            if (previewMode === PREVIEW_MODE.VIEW_ANALYTICS_DASHBOARD) {
                navigate({
                    pathname: RoutePaths.analyticsPreview,
                    search: `?${new URLSearchParams({
                        [URLSearchParamsKeys.instanceId]: row.entityId,
                        [URLSearchParamsKeys.templateId]: row.templateId,
                    }).toString()}`,
                })
            } else if (tabIndex && applicationId) {
                setSearchParams({
                    [URLSearchParamsKeys.applicationId]: applicationId,
                    [URLSearchParamsKeys.tabIndex]: tabIndex,
                    [URLSearchParamsKeys.pageView]: TAB_PAGE_VIEW.DETAILS_VIEW,
                    [URLSearchParamsKeys.instanceId]: row.entityId,
                    [URLSearchParamsKeys.templateId]: row.templateId,
                })
            } else {
                navigate({
                    pathname: RoutePaths.entityPreview,
                    search: `?${new URLSearchParams({
                        [URLSearchParamsKeys.instanceId]: row.entityId,
                        [URLSearchParamsKeys.templateId]: row.templateId,
                    }).toString()}`,
                })
            }
        },
        [previewMode, navigate, tabIndex, applicationId, setSearchParams],
    )

    const columns = useMemo(() => {
        let allColumns: any[] = []
        if (!columnVisibilityList?.length) {
            return []
        }
        const updatedTemplateColumns = columnVisibilityList
            ?.filter((item: ColumnOrderListType) => {
                return !columsnToExcludeInEntityListing[applicationId || '']?.[
                    Number(tabIndex)
                ]?.includes(item?.columnName)
            })
            .map(
                (item: ColumnOrderListType) =>
                    ({
                        header:
                            t(item.columnName) +
                            (item.unit ? ' (' + item.unit + ')' : ''),
                        accessorKey: item.attributeName,
                        ...item,
                    }) as IMRTColumn,
            )
            .map((item, index: number) => {
                const cellRenderer = (row: {
                    row: { original: IEntityListRecord }
                }) => {
                    if (item.accessorKey === 'entityStatus') {
                        const rawStatus = row.row.original?.status
                        let statusLabel: string
                        if (
                            isDeviceManagerListingView &&
                            rawStatus === EntityStatus.ACTIVE
                        ) {
                            const hasActiveRelation =
                                row.row.original?.hasActiveRelation === true
                            statusLabel = hasActiveRelation
                                ? DeviceManagerStatusToUI[EntityStatus.ACTIVE]
                                : DeviceManagerStatusToUI[
                                      DEVICE_MANAGER_REGISTERED
                                  ]
                        } else {
                            statusLabel =
                                EntityStatusBEtoUI[
                                    rawStatus as keyof typeof EntityStatusBEtoUI
                                ] || rawStatus
                        }
                        return <TruncatedText text={t(statusLabel)} />
                    }

                    const value =
                        row.row.original?.attributes?.[item.accessorKey]

                    if (isGPS(item) || isGeoFence(item)) {
                        return (
                            <GeoJSONTypeData
                                index={index}
                                dataValue={value}
                                item={item}
                            />
                        )
                    }
                    if (isURL(item)) {
                        return <URLTypeData dataValue={value} />
                    }
                    if (isPDFBase64(item)) {
                        return (
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <CertificateViewer pdfBase64={value} />
                            </Box>
                        )
                    }
                    if (isEntity(item) || isEntityJson(item)) {
                        return (
                            <EntityTypeData
                                dataValue={value}
                                orgId={row.row.original?.organizationId}
                            />
                        )
                    }
                    if (isJson(item)) {
                        return (
                            <EntityJsonTypeData item={item} dataValue={value} />
                        )
                    }
                    if (isFile(item)) {
                        return (
                            <EntityFileTypeData dataValue={value} item={item} />
                        )
                    }
                    if (isDateTime(item) && isStatic(item)) {
                        return <DatetimeTypeData dataValue={value} />
                    }
                    if (isDateTime(item) || isCreationDateTime(item)) {
                        return (
                            <DatetimeTypeData
                                dataValue={value}
                                showTimezone={false}
                            />
                        )
                    }
                    return <EntityTableCell dataValue={value} item={item} />
                }
                const sortableColumns =
                    item.metadata?.[AttributesMetadata.SORTING] ?? false

                const filterColumns =
                    item.metadata?.[AttributesMetadata.FILTER] ??
                    item.header === 'Type'

                return {
                    ...item,
                    Cell: cellRenderer,
                    Header: (d: any) => (
                        <EntityTableHeader text={d.column.columnDef.header} />
                    ),
                    enableSorting: sortableColumns,
                    enableColumnFilter: filterColumns,
                    Filter: (props: any): ReactElement => (
                        <CustomFilters<IColumn>
                            {...props}
                            templateId={templateId}
                            fetchAllOrgsForOrgFilter={
                                listQueryParams.fetchAll || false
                            }
                        />
                    ),
                }
            })

        const previewColumn = {
            header: '',
            accessorKey: 'viewid',
            id: 'viewid',
            Cell: (row: any) => (
                <IconButton
                    id={`row-${row.row.id}-preview-button`}
                    onClick={() => {
                        if (isPreviewEnabled || isInTransitMapView) {
                            onClickPreview(row.row.original)
                        } else {
                            onClickReadOnly(row.row.original)
                        }
                    }}
                    // onMouseEnter={() =>
                    //     props?.onShowMarkerInfo?.(row?.row?.original?.uid)
                    // }
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                >
                    <img src="/assets/images/icons/preview.svg" alt="Preview" />
                </IconButton>
            ),
            size: 40,
            grow: false,
            maxWidth: 40,
            enableResizing: false,
            enableSorting: false,
            enableColumnFilter: false,
        }
        allColumns = [...allColumns, previewColumn]
        if (canEdit) {
            const editColumn = {
                header: '',
                accessorKey: 'editid',
                id: 'editid',
                Cell: ({ row }: any) => {
                    if (
                        isDeviceManagerListingView &&
                        isCompletedDevice(row.original)
                    ) {
                        return null
                    }
                    return (
                        <IconButton
                            id={`row-${row.id}-edit-button`}
                            onClick={() => onClickEditIcon(row.original)}
                            aria-controls="simple-menu-preview"
                            aria-haspopup="true"
                            key="edit-preview"
                            disabled={
                                !canEditEntity(row.original, isSuperAdmin)
                            }
                            sx={{
                                opacity: canEditEntity(
                                    row.original,
                                    isSuperAdmin,
                                )
                                    ? 1
                                    : 0,
                            }}
                        >
                            <img
                                src="/assets/images/icons/edit.svg"
                                alt="Edit"
                            />
                        </IconButton>
                    )
                },
                size: 40,
                grow: false,
                maxWidth: 40,
                enableResizing: false,
                enableSorting: false,
                enableColumnFilter: false,
            }
            allColumns = [...allColumns, editColumn]
        }
        if (isInTransitMapView && isMaritimeTrackingEnabled) {
            const shipIconColumn = {
                header: '',
                accessorKey: 'shipIcon',
                id: 'shipIcon',
                Cell: (row: any) => {
                    const maritimeValue =
                        row?.row?.original?.attributes?.[
                            maritimeTrackingRelationName
                        ] || ''

                    const hasMaritime = Array.isArray(maritimeValue)
                        ? !!maritimeValue[0]?.uid
                        : !!maritimeValue?.uid

                    return hasMaritime ? (
                        <img
                            src="/assets/images/icons/Ship_Icon.svg"
                            alt="Ship Icon"
                        />
                    ) : null
                },
                size: 40,
                grow: false,
                maxWidth: 40,
                enableResizing: false,
                enableSorting: false,
                enableColumnFilter: false,
            }
            allColumns = [...allColumns, shipIconColumn]
        }
        allColumns = [...allColumns, ...updatedTemplateColumns]
        return allColumns
    }, [
        canEdit,
        columnVisibilityList,
        applicationId,
        tabIndex,
        isPreviewEnabled,
        isInTransitMapView,
        maritimeTrackingRelationName,
        isMaritimeTrackingEnabled,
        onClickPreview,
        onClickReadOnly,
        t,
        onClickEditIcon,
        templateId,
        listQueryParams.fetchAll,
        isSuperAdmin,
        isDeviceManagerListingView,
    ])

    // delete icon functions
    // delete icon functions
    const handleDeleteDialogOperation = useCallback(async () => {
        // UBQ-5177: ignore re-entrant clicks and empty selections so a double-click
        // can't fire a duplicate or empty-body delete request.
        if (isDeletingRef.current || rowsToDelete.length === 0) {
            return
        }
        isDeletingRef.current = true
        try {
            await updateEntityInstancesStatus(
                org?.id || '',
                rowsToDelete,
                'delete',
            )
            setRowSelection({})
            setRowsToDelete([])
            queryClient.invalidateQueries({
                queryKey: ['entity-instances-table-data', templateId, org?.id],
            })
            setOpenDeleteDialog(false)
        } finally {
            isDeletingRef.current = false
        }
    }, [org?.id, rowsToDelete, templateId, queryClient])

    const deleteEntitiesHandler = useCallback(() => {
        const keys = Object.keys(rowSelection)
        const rowsToDelete: number[] = []
        for (const k of keys) {
            const key = Number(k)
            const rowData: any = flatData[key]
            rowsToDelete.push(rowData.entityId)
        }
        setRowsToDelete(rowsToDelete)
        setOpenDeleteDialog(true)
    }, [rowSelection, flatData])

    const transferEntitiesHandler = useCallback(() => {
        setOpenTransfer(true)
    }, [])

    //instance Popup
    const handleOpenFields = useCallback(() => {
        dispatch(updateLoader(true))
        setOpenEntityInstance(true)
        setIsEdit(false)
        setEntityData({
            templateName: templateData?.name,
            templateId,
            entityId: '',
            orgId: '',
        })
    }, [dispatch, templateData?.name, templateId])

    const handleCloseFields = useCallback(
        (reload: boolean) => {
            setOpenEntityInstance(false)
            setEntityData({
                templateName: '',
                templateId: '',
                entityId: '',
                orgId: '',
            })
            if (reload) {
                queryClient.invalidateQueries({
                    queryKey: [
                        'entity-instances-table-data',
                        templateId,
                        org?.id,
                    ],
                })
            }
            dispatch(updateInstanceReadOnly(false))
        },
        [queryClient, templateId, org?.id, dispatch],
    )

    // Export popup state
    const [openExportPopup, setOpenExportPopup] = useState(false)
    const handleOpenExportPopup = useCallback(() => {
        setOpenExportPopup(true)
    }, [])
    const handleExportEntities = useCallback(
        async (selectedColumns: string[]) => {
            const filters = getColumnFilters(
                columnFilters,
                columnVisibilityList,
            )
            const queryParams: ExportShipmentEntityRecordsParams = {
                searchText: searchValue?.trim(),
                shipmentStatusFilter: debouncedShipmentStatusFilter,
                alarmStatusFilter: debouncedAlarmStatusFilter,
                searchAttributeName: searchValue
                    ? selectedColumn?.attributeName || ''
                    : '',
                searchAttributeType: searchValue
                    ? selectedColumn?.relationType === RELATION_TYPE_PARENT
                        ? SEARCH_ATTRIBUTE_TYPE_PARENT_RELATION
                        : selectedColumn?.attributeType || ''
                    : '',
                timezone: userTimeZone,
                currentLocationBounds,
                orderAttribute: sortParams.orderAttribute,
                orderBy: sortParams.orderBy,
                dateFilterAttributeId,
                fromDate,
                toDate,
                filters,
                filterBy: debouncedEntityStatus as EntityStatus[],
                entitySearch: !!searchValue,
                includeParentRelations: hasParentRelationColumns,
                ...(debouncedRelationFilter !== null && {
                    hasActiveRelation: debouncedRelationFilter,
                }),
                ...listQueryParams,
            }
            dispatch(updateLoader(true))
            await exportEntityRecordsAsXLS(
                templateId,
                org?.id || '',
                queryParams,
                selectedColumns,
            )
            dispatch(updateLoader(false))
        },
        [
            columnFilters,
            columnVisibilityList,
            searchValue,
            debouncedShipmentStatusFilter,
            debouncedAlarmStatusFilter,
            selectedColumn,
            userTimeZone,
            currentLocationBounds,
            sortParams,
            dateFilterAttributeId,
            fromDate,
            toDate,
            debouncedEntityStatus,
            hasParentRelationColumns,
            listQueryParams,
            dispatch,
            templateId,
            org?.id,
        ],
    )

    const handleRowClick = useCallback(
        (record: IEntityListRecord) => {
            if (isInTransitMapView && onShowMarkerInfo) {
                onShowMarkerInfo(record.uid)
            }
        },
        [isInTransitMapView, onShowMarkerInfo],
    )

    // handling column arrangmet
    const handleUpdateColumnOrder = useCallback(
        (columnsList: ColumnOrderListType[]) => {
            dispatch(updateEntityListColumns(columnsList))
        },
        [dispatch],
    )

    const handleResetColumnOrder = useCallback(() => {
        dispatch(
            getEntityListColumns({
                orgId: org?.id || '',
                templateId,
                isAdmin,
                applicationId: applicationId || '',
                tabIndex: tabIndex || '',
                includeParentRelations:
                    applicationId === Applications.facilityMonitoring.id &&
                    Number(tabIndex) === FMTABS.ASSET_VIEW,
            }),
        )
    }, [dispatch, org?.id, templateId, isAdmin, applicationId, tabIndex])

    const handleSaveColumnOrder = useCallback(async () => {
        const columnsToSave = columnVisibilityList.map((col) => ({
            attributeName: col.id,
            isDisplayable: col.selected,
        }))
        dispatch(updateLoader(true))
        await postColumnsSelections(templateId, org?.id || '', columnsToSave)
        dispatch(updateLoader(false))
    }, [columnVisibilityList, dispatch, templateId, org?.id])

    const setColumnFiltersHandler = useCallback(
        (
            columnsFiltersUpdate: React.SetStateAction<
                { id: string; value: any }[]
            >,
        ) => {
            const currentFilters = columnFilters
            const newFilters =
                typeof columnsFiltersUpdate === 'function'
                    ? columnsFiltersUpdate(currentFilters)
                    : columnsFiltersUpdate

            if (newFilters.length === 0 && currentFilters.length === 0) {
                return
            }
            const updatedColumnLevelFilters = newFilters.reduce(
                (acc, item) => {
                    acc[item.id] = {
                        type: 'entity',
                        isColumnLevelFilter: true,
                        value: item.value,
                    }
                    return acc
                },
                {} as Record<string, any>,
            )

            const updatedAllTableFilters = allTableFilters.map((filter) => {
                if (
                    filter.applicationId === applicationId &&
                    filter.tabIndex === tabIndexString &&
                    filter.entityTemplateId === templateId
                ) {
                    const nonColumnLevelFilters =
                        getNonColumnLevelFilters(filter)
                    return {
                        ...filter,
                        allAttributesFilters: {
                            ...nonColumnLevelFilters,
                            ...updatedColumnLevelFilters,
                        },
                    } as ITableFilters
                }
                return filter
            })
            dispatch(setFilterList(updatedAllTableFilters))
        },
        [
            columnFilters,
            dispatch,
            allTableFilters,
            applicationId,
            tabIndexString,
            templateId,
        ],
    )

    const clearAllFilters = useCallback(() => {
        const updatedAllTableFilters = allTableFilters.map((filter) => {
            if (
                filter.applicationId === applicationId &&
                filter.tabIndex === tabIndexString &&
                filter.entityTemplateId === templateId
            ) {
                // return {} as ITableFilter
                return {
                    ...filter,
                    allAttributesFilters: {},
                    gloalSearchText: {
                        ...filter.gloalSearchText,
                        searchText: '',
                    },
                    entityStatusFilter: {
                        ...filter.entityStatusFilter,
                        values: [],
                    },
                }
            }
            return filter
        })
        setHasSearchFilter(false)
        dispatch(setFilterList(updatedAllTableFilters))
        if (searchValue) {
            setTimeout(() => {
                queryClient.invalidateQueries({
                    queryKey: ['entity-instances-table-data'],
                })
                if (isInTransitMapView) {
                    setSearchText?.('')
                }
            }, 500)
        }
    }, [
        dispatch,
        allTableFilters,
        applicationId,
        tabIndexString,
        templateId,
        queryClient,
        isInTransitMapView,
        setSearchText,
        searchValue,
        setHasSearchFilter,
    ])

    const handleTransferEntities = useCallback(() => {
        setRowSelection({})
        setOpenTransfer(false)
        queryClient.invalidateQueries({
            queryKey: ['entity-instances-table-data'],
        })
    }, [queryClient])

    const handleMapLayoutSelectChange = useCallback(() => {
        const next = displayMapLayout === 'both' ? 'table-only' : 'both'
        setDisplayMapLayout(next)
        onMapLayoutChange?.(next)
    }, [displayMapLayout, onMapLayoutChange])

    const entityStatusFilterValues = useMemo(() => {
        return getEntityTableEntityStatusFilter(
            allTableFilters,
            templateId,
            applicationId,
            tabIndexString,
        )?.values
    }, [allTableFilters, templateId, applicationId, tabIndexString])

    const filtersCount = useMemo(() => {
        return (
            getColumnFilters(columnFilters, columnVisibilityList)?.length +
            (hasSearchFilter ? 1 : 0) +
            (dateRange?.[0] && dateRange?.[1] ? 1 : 0) +
            (shipmentStatusFilter ? 1 : 0) +
            (alarmStatusFilter ? 1 : 0) +
            (entityStatusFilterValues?.length ? 1 : 0)
        )
    }, [
        columnFilters,
        hasSearchFilter,
        shipmentStatusFilter,
        alarmStatusFilter,
        dateRange,
        columnVisibilityList,
        entityStatusFilterValues,
    ])

    const searchableColumns = useMemo(() => {
        return (
            columnVisibilityList
                ?.filter((column) => column?.searchable)
                .map((i) => ({
                    ...i,
                    columnName: t(i.columnName),
                })) ?? []
        )
    }, [columnVisibilityList, t])

    const shouldShowActions = !isInTransitMapView && canEdit

    const hasFilters = filtersCount > 0

    useEffect(() => {
        if (
            columnVisibilityTemplateId !== templateId ||
            columnVisibilityOrgId !== (org?.id || '')
        ) {
            dispatch(
                getEntityListColumns({
                    orgId: org?.id || '',
                    templateId,
                    isAdmin,
                    applicationId: applicationId || '',
                    tabIndex: tabIndex || '',
                    includeParentRelations:
                        applicationId === Applications.facilityMonitoring.id &&
                        Number(tabIndex) === FMTABS.ASSET_VIEW,
                }),
            )
            dispatch(updateEntityListColumns([]))
            dispatch(setScrollPosition(0))
        }
        setRowSelection({})
    }, [
        templateId,
        applicationId,
        dispatch,
        isAdmin,
        org?.id,
        tabIndex,
        columnVisibilityTemplateId,
        columnVisibilityOrgId,
    ])

    // Re-fetch columns only when user unit preferences genuinely change (e.g. °C → °F).
    useEffect(() => {
        if (userUnitsKey === prevUserUnitsKeyRef.current) return
        prevUserUnitsKeyRef.current = userUnitsKey

        if (userUnitsKey && templateId && org?.id && !isFetchingColumn) {
            dispatch(
                getEntityListColumns({
                    orgId: org?.id || '',
                    templateId,
                    isAdmin,
                    applicationId: applicationId || '',
                    tabIndex: tabIndex || '',
                    includeParentRelations:
                        applicationId === Applications.facilityMonitoring.id &&
                        Number(tabIndex) === FMTABS.ASSET_VIEW,
                }),
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userUnitsKey])

    useEffect(() => {
        if (mapLayout !== undefined) {
            setDisplayMapLayout(mapLayout)
        }
    }, [mapLayout])

    useEffect(() => {
        onTotalCountWithoutFiltersChange?.(totalDBRowCountWithoutFilters)
    }, [totalDBRowCountWithoutFilters, onTotalCountWithoutFiltersChange])

    return (
        <Box
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            {
                /**
                 * In Entity Listing pages present under Applications we don't display the template name
                 */

                !applicationId && (
                    <Box sx={{ marginBottom: '10px' }}>
                        <Typography variant="h4" component="h2">
                            {t(templateData.name)}
                        </Typography>
                    </Box>
                )
            }
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    background: theme.tableHeader.color,
                    borderRadius: '5px 5px 0px 0px',
                    padding: '0px 8px',
                    gap: '20px',
                }}
            >
                {isInTransitMapView ? (
                    <InTransitFilterRow
                        templateId={templateId}
                        applicationId={applicationId}
                        tabIndex={tabIndexString}
                        triggerSearch={triggerSearch}
                        searchableColumns={searchableColumns}
                        dateRange={dateRange}
                        updateDateRange={updateDateRange}
                        dateFilterLabel={DateFilterAttributeName}
                        filtersCount={filtersCount}
                        clearAllFilters={clearAllFilters}
                    />
                ) : (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '15px',
                            flexWrap: 'nowrap',
                            padding: '8px 0px',
                            minWidth: 0,
                            overflowX: 'auto',
                        }}
                    >
                        <Box>
                            <EntityListSearch
                                tabIndex={tabIndexString}
                                applicationId={applicationId}
                                templateId={templateId}
                                triggerSearch={triggerSearch}
                                searchableColumns={searchableColumns}
                            />
                        </Box>
                        {isDeviceManagerListingView && (
                            <Box
                                sx={{
                                    width: '150px',
                                    background: 'white',
                                    borderRadius: '5px',
                                }}
                            >
                                <EntityStatusFilter
                                    templateId={templateId}
                                    applicationId={applicationId}
                                    tabIndex={tabIndexString}
                                    label={`${templateData.name} Status`}
                                    isDeviceManager={true}
                                />
                            </Box>
                        )}
                        {hasFilters && (
                            <Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        background: '#00000042',
                                        color: '#fff',
                                        padding: '8px 15px 8px 12px',
                                        borderRadius: '25px',
                                        gap: '6px',
                                        cursor: 'pointer',
                                        minWidth: '158px',
                                        '&:hover': {
                                            background: '#00000048',
                                        },
                                    }}
                                    onClick={clearAllFilters}
                                >
                                    <Box>
                                        <Icon
                                            fontSize="small"
                                            id="clear-filters-button"
                                            aria-label={t('clearFilters')}
                                            title={t('clearFilters')}
                                        >
                                            <CloseOutlined
                                                sx={{
                                                    color: '#fff',
                                                    marginTop: '1px',
                                                }}
                                            />
                                        </Icon>
                                    </Box>
                                    <Box>
                                        <Typography>
                                            {t('clearFilters')}
                                        </Typography>
                                    </Box>
                                    <Box
                                        sx={{
                                            width: '20px',
                                            height: '20px',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            borderRadius: '25px',
                                            background: '#fff',
                                            color: '#000',
                                            marginLeft: '5px',
                                        }}
                                    >
                                        <Typography>{filtersCount}</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        )}
                    </Box>
                )}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: 'auto',
                        gap: '15px',
                        flexWrap: 'nowrap',
                        padding: '8px 0px',
                    }}
                >
                    <Box sx={{ marginLeft: 'auto' }}>
                        <TruncatedText
                            sx={{
                                fontSize: '14px',
                                color: '#7a7a7a',
                                fontWeight: 600,
                            }}
                        >
                            {flatData?.length > 0 && isInTransitMapView
                                ? t('loadedShipemtsOFtotalShipments', {
                                      loadedShipemts: totalDBRowCount,
                                      totalShipments:
                                          totalDBRowCountWithoutFilters,
                                  })
                                : t('loadedRecordsOFtotalRecords', {
                                      loadedRecords: totalDBRowCount,
                                      totalRecords:
                                          totalDBRowCountWithoutFilters,
                                  })}
                        </TruncatedText>
                    </Box>
                    {onMapLayoutChange !== undefined && (
                        <Tooltip
                            title={
                                displayMapLayout === 'both'
                                    ? t('tableOnly')
                                    : t('mapAndTable')
                            }
                            placement="top"
                        >
                            <IconButton
                                size="small"
                                onClick={handleMapLayoutSelectChange}
                                sx={{ padding: '2px' }}
                            >
                                <img
                                    src={
                                        displayMapLayout === 'both'
                                            ? '/assets/images/icons/ccl-table-view.png'
                                            : '/assets/images/icons/ccl-table-and-map-view.png'
                                    }
                                    alt={
                                        displayMapLayout === 'both'
                                            ? t('tableOnly')
                                            : t('mapAndTable')
                                    }
                                    width={20}
                                    height={20}
                                />
                            </IconButton>
                        </Tooltip>
                    )}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <Box marginLeft="auto" marginRight={'10px'}>
                            {/*TO DO: we need make this component as saparate coponent. we can reduce number line in single file*/}
                            <ColumnsArrangement
                                orgId={org?.id || ''}
                                templateId={templateId}
                                isAdmin={isAdmin}
                                isGuestUser={false}
                                keywordForLocalStorage="entityList"
                                columnsList={columnVisibilityList}
                                handleUpdateColumnOrder={
                                    handleUpdateColumnOrder
                                }
                                handleResetColumnOrder={handleResetColumnOrder}
                                handleSaveColumnOrder={handleSaveColumnOrder}
                            />
                        </Box>
                        <Button
                            onClick={handleOpenExportPopup}
                            sx={{
                                minWidth: '25px',
                                maxWidth: '30px',
                                marginLeft: '5px',
                            }}
                            id="export-entities-button"
                        >
                            <Tooltip title={t('exportAsXls')} placement="top">
                                <img
                                    src="/assets/images/icons/file_save.svg"
                                    alt="Export"
                                />
                            </Tooltip>
                        </Button>
                        {canImportExport && enableBulkUpload ? (
                            <Button
                                onClick={handleBulkActionClick}
                                sx={{
                                    minWidth: '25px',
                                    maxWidth: '30px',
                                    marginLeft: '5px',
                                }}
                                id="bulk-upload-download-button"
                            >
                                <Tooltip
                                    title={t('uploadManager.header.upload')}
                                    placement="top"
                                >
                                    <img
                                        src="/assets/images/icons/upload-icon.svg"
                                        alt="Upload/Download"
                                    />
                                </Tooltip>
                            </Button>
                        ) : null}
                        {(isSuperAdmin ||
                            (isDeviceManager && isDeviceTemplate)) &&
                        !isReportsListingView ? (
                            <Button
                                onClick={() => transferEntitiesHandler()}
                                disabled={!rowsSeletced}
                                sx={{
                                    minWidth: '25px',
                                    maxWidth: '30px',
                                    marginLeft: '10px',
                                    filter: rowsSeletced
                                        ? 'none'
                                        : 'grayscale(100%)',
                                    opacity: rowsSeletced ? 1 : 0.5,
                                }}
                                id="transfer-entities-button"
                            >
                                <Tooltip title={t('transfer')} placement="top">
                                    <SwapHorizOutlined
                                        sx={{
                                            color: theme.palette.primary.main,
                                            fontSize: 28,
                                        }}
                                    />
                                </Tooltip>
                            </Button>
                        ) : null}
                        {shouldShowActions ? (
                            <>
                                <Button
                                    onClick={() => deleteEntitiesHandler()}
                                    disabled={!rowsSeletced}
                                    sx={{
                                        minWidth: '25px',
                                        maxWidth: '30px',
                                        marginLeft: '10px',
                                        filter: rowsSeletced
                                            ? 'none'
                                            : 'grayscale(100%)',
                                        opacity: rowsSeletced ? 1 : 0.5,
                                    }}
                                    id="delete-entities-button"
                                >
                                    <img
                                        alt="Delete"
                                        src={`/assets/images/icons/delete-icon.svg`}
                                    />
                                </Button>
                                <Button
                                    onClick={handleOpenFields}
                                    sx={{
                                        minWidth: '25px',
                                        maxWidth: '30px',
                                        marginLeft: '25px',
                                        minHeight: '25px',
                                        maxHeight: '30px',
                                        marginRight: '10px',
                                    }}
                                    id="add-group-button"
                                >
                                    <img
                                        alt="Add"
                                        src={`/assets/images/icons/add-icon.svg`}
                                    />
                                </Button>
                            </>
                        ) : null}
                        {/* UBQ-4542: bulk shipment completion — CCL listing, Super Admin only
                            (System Administrator / organization:admin). Plain Org Admins (user:admin)
                            no longer see it; matches the backend isSuperAdmin() gate. FE proxy is
                            ORG_ADMIN per the UBQ-5213 precedent (isMemberOfSuperAdmins is null client-side).
                            Placed last in the toolbar icon cluster. */}
                        {isInTransitMapView && isSuperAdmin && (
                            <BulkCompleteAction
                                orgId={org?.id || ''}
                                templateId={templateId}
                                selectedShipmentIds={selectedRowInstanceIds}
                                hasCompletedSelection={hasCompletedSelection}
                                onChanged={() =>
                                    queryClient.invalidateQueries({
                                        queryKey: [
                                            'entity-instances-table-data',
                                        ],
                                    })
                                }
                                onCompleted={() => setRowSelection({})}
                            />
                        )}
                    </Box>
                </Box>
            </Box>
            <Box
                sx={{ flex: '1 1 auto', overflow: 'hidden', minHeight: 0 }}
                id="CCL-Shipments-Table-Container"
            >
                <DynamicTable
                    tableIdentifier={`${applicationId || 'NA'}-${templateId}-${tabIndexString}`}
                    columns={columns}
                    data={flatData?.length ? flatData : []}
                    totalDBRowCount={totalDBRowCount}
                    fetchNextPage={fetchNextPage}
                    isError={isError}
                    isFetching={isFetching}
                    isLoading={
                        isLoading ||
                        isFetchingColumn ||
                        columnVisibilityList.length === 0
                    }
                    setRowSelection={setRowSelection}
                    rowSelection={rowSelection}
                    hasRowSelection={canEdit}
                    hasRowSelectionForEach={
                        (isDeviceTemplate && isDeviceManager) || isSuperAdmin
                    }
                    columnVisibility={columnVisibility}
                    height={isInTransitMapView ? '100%' : 'calc(100vh - 290px)'}
                    columnOrder={columnOrder}
                    sortParams={sortParams}
                    setSortParams={setSortParams}
                    onRowClick={
                        isInTransitMapView && onShowMarkerInfo
                            ? handleRowClick
                            : undefined
                    }
                    columnFilters={columnFilters}
                    setColumnFilters={setColumnFiltersHandler}
                />
                <ConfirmationDialog
                    openDialog={openDeleteDialog}
                    handleComfirm={() => handleDeleteDialogOperation()}
                    handleClose={() => setOpenDeleteDialog(false)}
                    DialogHeaderText={t('confirmDelete')}
                    DialogBodyText={t('deleteRecordsConfirmation')}
                />
            </Box>

            {openEntityInstance && (
                <EntityInstance
                    isEdit={isEdit}
                    handleCloseFields={handleCloseFields}
                    entityData={entityData}
                    instanceType={
                        isInTransitMapView
                            ? EntityInstanceTypes.IN_TRANSIT
                            : EntityInstanceTypes.NORMAL
                    }
                />
            )}
            {openExportPopup && (
                <ExportColumnsPopup
                    open={openExportPopup}
                    onClose={() => setOpenExportPopup(false)}
                    columns={columnVisibilityList}
                    onExport={handleExportEntities}
                />
            )}
            <EntityBulkUploadModal
                open={uploadModalOpen}
                onClose={() => setUploadModalOpen(false)}
                templates={currentTemplates}
                orgId={org?.id || ''}
                initialTemplateId={bulkUploadInitialTemplateId}
                mode={modalMode}
                showSubTypes={true}
            />
            {openTransfer && (
                <TransferInstancesModal
                    templateId={templateId}
                    entityIds={selectedRowInstanceIds}
                    excludeOrgs={selectedRowOrgIds}
                    onClose={() => setOpenTransfer(false)}
                    onTransfer={() => handleTransferEntities()}
                />
            )}
        </Box>
    )
}

const EntityWrapper: React.FC<IEntity> = (props) => {
    return (
        <ErrorBoundary>
            <EntityList {...props} />
        </ErrorBoundary>
    )
}

const MemoizedEntityWrapper = memo(EntityWrapper)
export default MemoizedEntityWrapper
